import { Component } from "@angular/core";

@Component({
  selector: "app-icon-chevron-right",
  standalone: true,
  imports: [],
  templateUrl: "./chevron-right.component.html",
})
export class ChevronRightIconComponent {}
